import { TLP_FAVORITE_SIGN_IN_COMPLETED_SESSION_KEY } from "@/constants/app";
import { PAGE_TYPE } from "@/libs/analytics/types";
import { TextButton } from "@/src/components/links/components/TextButton";
import { Body8 } from "@/src/components/typography/components/Body";
import { useHandleSignInClicked } from "@/src/routes/auth/routes/signin/helpers";
import { PropsWithChildren } from "react";
import { MAP_FAVORITE_ERROR_COPY } from "../../../../../../constants";
import { FavoriteError } from "../../../../../../types";

const TokenListingFavoriteErrorToast: React.FC<
  PropsWithChildren<{ copy: string }>
> = ({ copy, children }) => {
  return (
    <div className="flex flex-col">
      <Body8>{copy}</Body8>
      {children}
    </div>
  );
};

const FavoriteToastSignInError = ({ pageType }: { pageType: PAGE_TYPE }) => {
  const signIn = useHandleSignInClicked(
    TLP_FAVORITE_SIGN_IN_COMPLETED_SESSION_KEY,
    pageType,
  );
  return (
    <TokenListingFavoriteErrorToast
      copy={MAP_FAVORITE_ERROR_COPY[FavoriteError.SIGN_IN]}
    >
      <TextButton
        onClick={signIn}
        size="xs"
        className="w-fit"
        linkType="underlined"
      >
        Sign In to Nike
      </TextButton>
    </TokenListingFavoriteErrorToast>
  );
};

export const MapFavoriteErrorToast = (pageType: PAGE_TYPE) => ({
  [FavoriteError.SIGN_IN]: <FavoriteToastSignInError pageType={pageType} />,
  [FavoriteError.ERROR]: (
    <TokenListingFavoriteErrorToast
      copy={MAP_FAVORITE_ERROR_COPY[FavoriteError.ERROR]}
    />
  ),
});

export default TokenListingFavoriteErrorToast;
